import Overview from './overview.vue';
import MobFull from '@/rebuild/materials/shared/quarterly_performance/mobile/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
};